import { cn } from '@/lib/utils';

// Every measurement is a ratio of the phone's width, so the whole mockup scales
// from the `--pw` custom property the consumer sets per breakpoint.

function StatusBarIcons() {
  return (
    <svg
      className="absolute left-[calc(var(--pw)*0.69832)] top-[calc(var(--pw)*0.09797)] w-[calc(var(--pw)*0.18438)]"
      viewBox="0 0 72.93 11.2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g opacity="0.9">
        <rect x="0" y="7.11" width="3.09" height="3.708" rx="1" fill="white" />
        <rect x="4.33" y="5.26" width="3.09" height="5.562" rx="1" fill="white" />
        <rect x="8.96" y="3.1" width="3.09" height="7.725" rx="1" fill="white" />
        <rect x="13.29" y="0.62" width="3.09" height="10.197" rx="1" fill="white" />
      </g>
      <g
        opacity="0.9"
        transform="translate(25.03 0)"
        fill="white"
      >
        <path d="M15.805 3.28557C13.7897 1.25641 10.9973 0 7.91154 0C4.81642 0 2.01659 1.26397 0 3.30391L1.74801 5.05201C3.31722 3.45941 5.49918 2.47211 7.91154 2.47211C10.3147 2.47211 12.489 3.45183 14.0568 5.03364L15.805 3.28557Z" />
        <path d="M12.9644 6.12617C11.6761 4.82395 9.88799 4.01718 7.91154 4.01718C5.92574 4.01718 4.13019 4.83155 2.84057 6.14456L4.58874 7.89274C5.43083 7.02705 6.60849 6.48929 7.91154 6.48929C9.20539 6.48929 10.3754 7.01939 11.2162 7.87427L12.9644 6.12617Z" />
        <path d="M10.1237 8.96686C9.56253 8.39157 8.77868 8.03436 7.91154 8.03436C7.03505 8.03436 6.2438 8.39926 5.68145 8.98541L7.89328 11.1972L10.1237 8.96686Z" />
      </g>
      <g transform="translate(50.37 1.24)">
        <rect
          x="0.4635"
          y="0.4635"
          width="18.85"
          height="8.034"
          rx="4.5"
          stroke="white"
          strokeWidth="0.927"
          opacity="0.6"
        />
        <rect x="0.62" y="0.62" width="18.541" height="7.725" rx="4" fill="white" opacity="0.9" />
        <rect x="21.32" y="3.09" width="1.236" height="2.781" rx="0.618" fill="white" opacity="0.6" />
      </g>
    </svg>
  );
}

function DynamicIsland() {
  return (
    <div className="absolute left-1/2 top-[calc(var(--pw)*0.07421)] h-[calc(var(--pw)*0.08438)] w-[calc(var(--pw)*0.28906)] -translate-x-1/2 overflow-hidden rounded-full bg-black">
      <div className="absolute left-[4.863%] top-1/2 w-[19.459%] -translate-y-1/2 rounded-full bg-[#141414] opacity-40 aspect-square">
        <div className="absolute left-[17.48%] top-[17.48%] w-[65%] rounded-full bg-black aspect-square" />
      </div>
      <div className="absolute left-[72.968%] top-1/2 w-[14.054%] -translate-y-1/2 rounded-full border border-[#0e0e0e] bg-[#121212] opacity-75 aspect-square" />
    </div>
  );
}

export default function PhoneMockup({
  className,
  screenClassName,
  children,
}: {
  className?: string;
  screenClassName?: string;
  children?: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        'relative w-[var(--pw)] h-[calc(var(--pw)*2.06407)] rounded-[calc(var(--pw)*0.16406)] bg-black',
        className,
      )}
      aria-hidden="true"
    >
      <div
        className={cn(
          'absolute inset-[calc(var(--pw)*0.04297)] overflow-hidden rounded-[calc(var(--pw)*0.13887)] bg-[#03251b]',
          screenClassName,
        )}
      >
        {children}
      </div>

      <div className="pointer-events-none absolute inset-0 rounded-[calc(var(--pw)*0.16406)] border-[#3d3d3d] [border-width:calc(var(--pw)*0.00391)]" />
      <div className="pointer-events-none absolute inset-[calc(var(--pw)*0.0039)] rounded-[calc(var(--pw)*0.16016)] border-[#929292] [border-width:calc(var(--pw)*0.01016)]" />
      <div className="pointer-events-none absolute inset-[calc(var(--pw)*0.0039)] rounded-[calc(var(--pw)*0.16094)] border-[#616161] blur-[0.06rem] [border-width:calc(var(--pw)*0.00391)]" />
      <div className="pointer-events-none absolute inset-[calc(var(--pw)*0.01797)] rounded-[calc(var(--pw)*0.1461)] border-[#646464] [border-width:calc(var(--pw)*0.00156)]" />

      <div className="absolute left-[calc(var(--pw)*0.16079)] top-[calc(var(--pw)*0.11516)] -translate-y-1/2 font-geist text-[calc(var(--pw)*0.04298)] font-semibold leading-none text-white">
        9:41
      </div>
      <StatusBarIcons />
      <DynamicIsland />
    </div>
  );
}
